/* tslint:no-commented-code */
import type { Host, Network, Random } from '@jet/environment';
import { Router } from '@jet/environment/routing';
import { makeMetatype } from '@jet/environment/util/metatype';
import { Dispatcher } from '../base/dispatcher';
import type { Metrics } from '../metrics';
import type {
    Bag,
    Bundle,
    Features,
    Locale,
    Localization,
    Logger,
    LoggerFactory,
} from '.';
import { Storage } from '../utilities/storage/Storage';
import type { SubscriptionStatusCoordinator } from './subscription-status-coordinator';

// tslint:disable-next-line:variable-name
export const ObjectGraphType = {
    bag: makeMetatype<Bag>('bag'),
    bundle: makeMetatype<Bundle>('bundle'),
    features: makeMetatype<Features>('features'),
    host: makeMetatype<Host>('host'),
    dispatcher: makeMetatype<Dispatcher>('dispatcher'), // <- Use this one.
    intentDispatcher: makeMetatype<Dispatcher>('dispatcher'), // <- TODO Deprecate.
    localization: makeMetatype<Localization>('localization'),
    locale: makeMetatype<Locale>('locale'),
    logger: makeMetatype<Logger>('logger'),
    loggerFactory: makeMetatype<LoggerFactory>('loggerFactory'),
    metrics: makeMetatype<Metrics>('metrics'),
    network: makeMetatype<Network>('network'),
    random: makeMetatype<Random>('random'),
    router: makeMetatype<Router>('router'),
    storage: makeMetatype<Storage>('storage'),
    subscriptionStatusCoordinator: makeMetatype<SubscriptionStatusCoordinator>(
        'subscriptionStatusCoordinator',
    ),
};
